import { render, staticRenderFns } from "./campaign.vue?vue&type=template&id=2cc05146&"
import script from "./campaign.vue?vue&type=script&lang=js&"
export * from "./campaign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2cc05146')) {
      api.createRecord('2cc05146', component.options)
    } else {
      api.reload('2cc05146', component.options)
    }
    module.hot.accept("./campaign.vue?vue&type=template&id=2cc05146&", function () {
      api.rerender('2cc05146', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/email/campaign.vue"
export default component.exports